import Reveal from "@/components/feature/Reveal";
import { clinic } from "@/mocks/clinic";
import { ReserveButton } from "@/components/layout/ReserveButton";
import { LineButton } from "@/components/layout/LineButton";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-primary-700 py-20 md:py-28 lg:py-32">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-20 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full border border-background-50/10"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-40 top-1/2 h-[460px] w-[460px] -translate-y-1/2 rounded-full border border-background-50/10"
      />
      <div className="u-container relative">
        <Reveal>
          <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
            <span className="en-eyebrow text-[10px] text-accent-300 md:text-[11px]">CONTACT / RESERVATION</span>
            <h2 className="mt-7 font-heading text-[26px] leading-[1.6] text-background-50 md:text-[36px] whitespace-pre-line">
              {"自分に自信を持つために、\n美容医療という選択を。"}
            </h2>
            <p className="mt-7 max-w-xl text-[13px] leading-[2.2] text-background-200 md:text-sm">
              施術が決まっていない方も、まずはお気軽にご相談ください。一人ひとりのお悩みに合わせて、納得できる美容医療をご提案します。
            </p>

            <div className="mt-10 flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row sm:items-center">
              <ReserveButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-8 py-3.5 text-[14px] font-medium text-primary-700 transition-colors hover:bg-secondary-100">
                <i className="ri-calendar-check-line text-base" aria-hidden />
                WEB予約
              </ReserveButton>
              <LineButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-8 py-3.5 text-[14px] text-background-50 transition-colors hover:bg-background-50/10">
                <i className="ri-line-fill text-base" aria-hidden />
                LINEで相談
              </LineButton>
              <a
                href={clinic.telHref}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-8 py-3.5 text-[14px] text-background-200 transition-colors hover:text-background-50"
              >
                <i className="ri-phone-line text-base" aria-hidden />
                電話する
              </a>
            </div>

            <p className="mt-8 text-[12px] tracking-wide text-background-200/80">
              {clinic.hours} ／ 渋谷駅近く
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}